<template>
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="32"
      height="32"
      rx="8"
      fill="url(#paint0_linear_77_120317)"
    />
    <path
      d="M21.9936 5.00717H10.006C6.69422 5.00717 4 7.70219 4 11.0149V21.9851C4 25.2978 6.69422 27.9929 10.006 27.9929H21.9936C25.3054 27.9929 27.9996 25.2978 27.9996 21.9851V11.0149C27.9996 7.70219 25.3054 5.00717 21.9936 5.00717ZM6.11873 11.0149C6.11873 8.87116 7.86285 7.12653 10.006 7.12653H21.9936C24.1368 7.12653 25.8809 8.87116 25.8809 11.0149V21.9851C25.8809 24.1289 24.1368 25.8735 21.9936 25.8735H10.006C7.86285 25.8735 6.11873 24.1289 6.11873 21.9851V11.0149Z"
      fill="white"
    />
    <path
      d="M16.0007 22.0872C19.0804 22.0872 21.5873 19.5809 21.5873 16.499C21.5873 13.417 19.0817 10.9107 16.0007 10.9107C12.9196 10.9107 10.4141 13.417 10.4141 16.499C10.4141 19.5809 12.9196 22.0872 16.0007 22.0872ZM16.0007 13.0314C17.9131 13.0314 19.4685 14.5874 19.4685 16.5003C19.4685 18.4133 17.9131 19.9692 16.0007 19.9692C14.0883 19.9692 12.5328 18.4133 12.5328 16.5003C12.5328 14.5874 14.0883 13.0314 16.0007 13.0314Z"
      fill="white"
    />
    <path
      d="M22.1068 11.8131C22.9361 11.8131 23.612 11.1383 23.612 10.3074C23.612 9.4765 22.9375 8.80173 22.1068 8.80173C21.2761 8.80173 20.6016 9.4765 20.6016 10.3074C20.6016 11.1383 21.2761 11.8131 22.1068 11.8131Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_77_120317"
        x1="4.67505"
        y1="27.8249"
        x2="27.3249"
        y2="5.17617"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAAD4F" />
        <stop offset="0.35" stop-color="#DD2A7B" />
        <stop offset="0.62" stop-color="#9537B0" />
        <stop offset="1" stop-color="#515BD4" />
      </linearGradient>
    </defs>
  </svg>
</template>
